// @flow
import React, { Component } from 'react';
import { EmptyTableTd } from './EmptyTableStyles';
import SectionLoader from './SectionLoader';

type Props = {
  columns: number
};

export default class TableLoader extends Component<Props> {
  render() {
    return (
      <tr>
        <EmptyTableTd colSpan={this.props.columns}>
          <SectionLoader />
        </EmptyTableTd>
      </tr>
    );
  }
}
